import Vue from 'vue';
import Router from 'vue-router';
import Login from '../page/login/login.vue';
import NotFound from '../page/404.vue';
import NoJurisdiction from '../page/NoJurisdiction.vue';
import Admin from '../components/layout/layout.vue';
import goodsList from '../page/productsManage/goodsList/goodsList.vue'; //商品列表
import gameList from '../page/productsManage/gameList/gameList.vue'; //游戏列表
import lotteryActivity from '../page/activityManage/lotteryActivity/lotteryActivity.vue'; //抽奖活动配置
import taskRecords from '../page/activityManage/taskRecords/taskRecords.vue'; //游戏任务管理
import taskDataDetails from '../page/activityManage/taskDataDetails/taskDataDetails.vue'; //任务数据明细
import userList from '../page/userManage/userList/userList.vue'; //用户列表
import integralDetails from '../page/userManage/integralDetails/integralDetails.vue'; //积分详情
import advertisingManage from '../page/advertisingManage/index.vue'; //广告管理
import pointsLotteryPage from '../page/activityManage/pointsLotteryPage/pointsLotteryPage.vue'; //积分抽奖页面配置
import packetRecord from '../page/activityManage/packetRecord/packetRecord.vue'; //红包发放统计
import netBarAccountManage from '../page/netBarAccountManage/index.vue'; //网关账号管理
import lotteryActivityTaskPrizes from '../page/activityManage/lotteryActivityTaskPrizes/lotteryActivityTaskPrizes.vue'; //积分抽奖活动奖品配置
import gameTaskPrizes from '../page/activityManage/gameTaskPrizes/gameTaskPrizes.vue'; //游戏任务奖品配置
import pointsStore from '../page/activityManage/pointsStore/pointsStore.vue'; //积分商城配置


Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'login-登录',
    //   redirect: {
    //     name: 'login'
    //   }
    // },
    {
      path: '*',
      name: 'notFound',
      component: NotFound
    }, 
    {    // 无任何权限
      path: '/nojurisdiction',
      name: 'noJurisdiction',
      component: NoJurisdiction
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'goodsList-home',
      redirect: {
        name: 'goodsList'
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      children: [
        {
          path: '/goodsList',
          name: 'goodsList',
          meta: {
            name: '商品管理 / 商品列表'
          },
          component: goodsList
        },
        {
          path: '/gameList',
          name: 'gameList',
          meta: {
            name: '商品管理 / 游戏列表'
          },
          component: gameList
        },
        {
          path: '/pointsStore',
          name: 'pointsStore',
          meta: {
            name: '活动管理 / 积分商城配置'
          },
          component: pointsStore
        },
        {
          path: '/lotteryActivity',
          name: 'lotteryActivity',
          meta: {
            name: '活动管理 / 积分抽奖活动配置'
          },
          component: lotteryActivity
        },
        {
          path: '/pointsLotteryPage',
          name: 'pointsLotteryPage',
          meta: {
            name: '活动管理 / 积分抽奖页面配置'
          },
          component: pointsLotteryPage
        },
        {
          path: '/lotteryActivityTaskPrizes',
          name: 'lotteryActivityTaskPrizes',
          meta: {
            name: '活动管理 / 积分抽奖活动奖品配置'
          },
          component: lotteryActivityTaskPrizes
        },
        {
          path: '/packetRecord',
          name: 'packetRecord',
          meta: {
            name: '活动管理 / 红包发放统计'
          },
          component: packetRecord
        },
        {
          path: '/taskRecords',
          name: 'taskRecords',
          meta: {
            name: '活动管理 / 游戏任务管理'
          },
          component: taskRecords
        },
        {
          path: '/taskDataDetails',
          name: 'taskDataDetails',
          meta: {
            name: '活动管理 / 任务数据明细'
          },
          component: taskDataDetails
        },
        {
          path: '/gameTaskPrizes',
          name: 'gameTaskPrizes',
          meta: {
            name: '活动管理 / 游戏任务奖品配置'
          },
          component: gameTaskPrizes
        },
        {
          path: '/userList',
          name: 'userList',
          meta: {
            name: '用户管理 / 用户列表'
          },
          component: userList
        },
        {
          path: '/integralDetails',
          name: 'integralDetails',
          meta: {
            name: '用户管理 / 积分详情'
          },
          component: integralDetails
        },
        {
          path: '/advertisingManage',
          name: 'advertisingManage',
          meta: {
            name: '广告管理 / 广告'
          },
          component: advertisingManage
        },
        {
          path: '/netBarAccountManage',
          name: 'netBarAccountManage',
          meta: {
            name: '网关账号管理 / 网关账号'
          },
          component: netBarAccountManage
        },
        
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js